import { Observer } from 'rxjs/Rx';
import { Injectable } from '@angular/core';

import { plainToClass } from 'class-transformer';
import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';

import { Address } from 'app/shared/models/address.model';
import { EntityType } from 'app/shared/models/entity-id-details.model';

/**
 * Service for address information component.
 */
@Injectable()
export class AddressInformationService {
    constructor(private requestService: ObservableRequestService) { }

    // Load all addreses.
    loadAddressInformation(id: number, entityType: EntityType): Observable<any> {
        return this.requestService.getRequest(
            `${(entityType.toString().toLowerCase() === 'person' ?
                ConstantsService.LIST_PERSON_ADDRESS_INFORMATION :
                ConstantsService.LIST_ORG_ADDRESS_INFORMATION)}/${id}`
        ).map(response => {
            return plainToClass(Address, response.arrResult as Object[]);
        });
    }

    // Add/Update Address Information.
    saveAddressInformation(addressSaveData: Address, action: string): Observable<any> {
        if (action.toLowerCase() == 'add') {
            return this.requestService.postRequest(ConstantsService.SAVE_DELETE_ADDRESS_INFORMATION,
                JSON.stringify(addressSaveData),
                this.requestService.getJSONContentType());
        }
        else {
            return this.requestService.putRequest(ConstantsService.SAVE_DELETE_ADDRESS_INFORMATION,
                JSON.stringify(addressSaveData),
                this.requestService.getJSONContentType());
        }
    };

    deleteAddressRecord(addressDeleteData: Address): Observable<any> {
        return this.requestService.deleteRequest(
            ConstantsService.SAVE_DELETE_ADDRESS_INFORMATION,
            this.requestService.serialize({
                entityid: addressDeleteData.entityId,
                locationid: addressDeleteData.id
            }),
            this.requestService.getFormEncodedContentType());
    }

    getLatLngFromAddress(address: string) {
        const geocoder = new google.maps.Geocoder();
        return Observable.create((observer: Observer<google.maps.LatLng>) => {
            geocoder.geocode({ 'address': address },
                (results: google.maps.GeocoderResult[], status: google.maps.GeocoderStatus) => {
                    if (status === google.maps.GeocoderStatus.OK) {
                        observer.next(results[0].geometry.location);
                        observer.complete();
                    } else {
                        console.error(results);
                        console.error(status);
                        observer.error({});
                    }
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/details/addressinformation/address-information.service.ts